<template>
  <div class="main-block">
    <div class="main-block__header">
      <h2 class="main-block__title">{{ vacancy.title ? vacancy.title : 'Без названия' }}</h2>
      <span class="main-block__status"
            v-if="$route.meta.type === 'vacancy'">{{ actionTitle}}</span>
    </div>
    <p v-if="vacancy?.is_fix_salary" class="main-block__salary">{{
        vacancy?.fix_salary ? `${vacancy?.fix_salary?.toLocaleString('ru')} ₽` : 'Не указано'
      }}</p>

    <p v-if="vacancy?.salary_from && !vacancy?.salary_to" class="main-block__salary">{{
        vacancy?.salary_from
            ? `${'От ' + vacancy?.salary_from?.toLocaleString('ru')} ₽`
            : 'Не указано'
      }}</p>

    <p v-if="!vacancy?.salary_from && vacancy?.salary_to" class="main-block__salary">{{
        vacancy?.salary_to
            ? `${'До ' + vacancy?.salary_to?.toLocaleString('ru')} ₽`
            : 'Не указано'
      }}</p>


    <p v-if="vacancy?.salary_from && vacancy?.salary_to" class="main-block__salary">{{
        vacancy?.salary_from
          ? `${vacancy?.salary_from?.toLocaleString('ru')}  ${vacancy?.salary_to ? '- ' + vacancy?.salary_to?.toLocaleString('ru') : ''}   ₽`
          : 'Не указано'
      }}</p>

    <VDivider />

    <div class="main-block__fields">
      <div class="main-block__fields-title">Основная информация</div>

      <div class="main-block__fields-content">
        <div class="main-block__fields-list">
          <div class="main-block__field">
            <div class="main-block__field-name">Должность</div>
            {{
              vacancy?.speciality_name ? vacancy.speciality_name : '-'
            }}
          </div>
<!--          <div class="main-block__field">-->
<!--            <div class="main-block__field-name">Подразделение:</div>-->
<!--            {{-->
<!--              vacancy?.working_conditions?.department ? vacancy.working_conditions.department : 'Не указано'-->
<!--            }}-->
<!--          </div>-->
<!--          <div class="main-block__field">-->
<!--            <div class="main-block__field-name">Регион</div>-->
<!--            {{ vacancy?.region_name ? vacancy.region_name : '-' }}-->
<!--          </div>-->
          <div class="main-block__field">
            <div class="main-block__field-name">Место работы</div>
            {{
              vacancy?.place_of_work ? vacancy.place_of_work : '-'
            }}
          </div>
<!--          <div class="main-block__field">-->
<!--            <div class="main-block__field-name">Условия договора</div>-->
<!--            {{-->
<!--              vacancy?.terms_of_contract === 'OpenEnded' ? 'Бессрочный' : 'Срочный'-->
<!--            }}-->
<!--          </div>-->
<!--          <div class="main-block__field">-->
<!--            <div class="main-block__field-name">Срок договора</div>-->
<!--            {{-->
<!--              vacancy?.terms_of_contract ? vacancy?.terms_of_contract === 'FixedTerm' ? 'Срочный' : 'Бессрочный' : '-'-->
<!--            }}-->
<!--          </div>-->
          <div class="main-block__field">
            <div class="main-block__field-name">Опыт работы</div>
            {{
              vacancy?.work_experience ? vacancy.work_experience : '-'
            }}
          </div>
<!--          <div class="main-block__field">-->
<!--            <div class="main-block__field-name">Образование</div>-->
<!--            {{-->
<!--              vacancy?.education_level ? vacancy.education_level : '-'-->
<!--            }}-->
<!--          </div>-->
          <!--                    <div class="main-block__field">-->
          <!--                        <div class="main-block__field-name">Трудовые функции:</div>-->
          <!--                        {{-->
          <!--                            vacancy.worker_functions_required ? 'Обязательно' : 'Необязательно'-->
          <!--                        }}-->
          <!--                    </div>-->
<!--          <div class="main-block__field">-->
<!--            <div class="main-block__field-name">График работы</div>-->
<!--            {{ vacancy?.schedule ? vacancy.schedule : '-' }}-->
<!--          </div>-->
<!--          <div class="main-block__field">-->
<!--            <div class="main-block__field-name">Дорожные расходы</div>-->
<!--            {{-->
<!--              vacancy?.include_traveling_expenses ? 'Включены' : 'Не включены'-->
<!--            }}-->
<!--          </div>-->
          <div class="main-block__field">
            <div class="main-block__field-name">Подразделение</div>
            {{ vacancy?.division_name ? vacancy.division_name : '-' }}
          </div>
          <div class="main-block__field">
            <div class="main-block__field-name">Юридическое лицо</div>
            {{ vacancy?.legal_entity_name ? vacancy.legal_entity_name : '-' }}
          </div>
        </div>
      </div>
    </div>

    <VDivider />

    <div class="main-block__description">
      <div class="main-block__description-title">Описание вакансии</div>
      <p class="main-block__description-text" v-html="vacancy?.description ? vacancy.description : '-'"></p>
    </div>
  </div>
</template>

<script setup>
import {computed} from "vue";
import VDivider from "@/components/UI/VDivider/index.vue";

const props = defineProps({
  vacancy: {
    type: Object,
    required: true,
  },
  actions: Object,
})

const actionTitle = computed(() => {
  if(!props.actions?.save_draft && !props.actions?.save_vacancy) {
    return 'Закрыта'
  } else {
    return props.vacancy.is_published ? 'Открыта ' : 'Черновик'
  }
})
</script>

<style scoped lang="scss">
.main-block {
  width: 100%;
  padding: 24px;
  border-radius: 16px;
  overflow: hidden;
  background-color: #fff;
  box-shadow: 2px 2px 8px 0 #0000000A;

  &__title {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-size: 20px;
    font-weight: 600;
  }

  &__salary {
    margin-top: 4px;
    font-size: 16px;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__status {
    display: block;
    padding: 2px 4px;
    border-radius: 4px;
    background-color: $dark-blue;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
  }

  &__fields {
    margin-top: 24px;
  }

  &__fields-title {
    font-size: 14px;
    font-weight: 600;
  }

  &__fields-content {
    margin-top: 12px;
    display: flex;
  }

  &__fields-list {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
  }

  &__field {
    font-size: 14px;
    font-weight: 400;
    width: 200px;
  }

  &__field-name {
    width: 142px;
    margin-bottom: 4px;
    color: $gray;
  }

  &__description {
    margin-top: 24px;
  }

  &__description-title {
    font-size: 14px;
    font-weight: 600;
  }

  &__description-text {
    margin-top: 12px;
    font-size: 14px;

    &::v-deep(ul) {
      margin-top: 3px;
      padding-left: 21px;

      li {
        &:not(:first-child) {
          margin-top: 3px;
        }
      }
    }

    &::v-deep(ol) {
      margin-top: 3px;
      padding-left: 20px;

      li {
        &:not(:first-child) {
          margin-top: 3px;
        }
      }
    }
  }
}
</style>
